import React from 'react'
import { CardWithImage, IProps as ICard } from 'marketing-site/src/library/elements/CardWithImage'
import { ICardWithImage as IContentfulCardWithImage } from 'marketing-site/@types/generated/contentful'

import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { transformCTALink } from './ContentfulCTALink'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { transformImage } from './ContentfulImage'

export const ContentfulCardWithImage = (card: IContentfulCardWithImage): React.ReactElement => (
  <EntryMarker entry={card}>
    {() => <CardWithImage {...transformCardWithImage(card)} />}
  </EntryMarker>
)

export function transformCardWithImage({ sys, fields }: IContentfulCardWithImage): ICard {
  return {
    ...fields,
    contentType: sys.contentType.sys.id,
    title: fields.titleRichText && documentToHtmlString(fields.titleRichText),
    imageRef: transformImage(fields.imageRef),
    tags: fields.tags && fields.tags.map(transformCTALink),
    body: fields.bodyText,
    cta: fields.cta && transformCTALink(fields.cta),
    altText: fields.imageRef.fields.altText,
  }
}
